import * as angular from 'angular';
const $q: ng.IQService = angular.injector(['ng']).get('$q');

var document = window.document;

           function loader(createElement) {
                var promises = {};

                return function(url) {
                    if (typeof promises[url] === 'undefined') {
                        var element = createElement(url);
                        var deferred = $q((resolve, reject)=> {
                            element.onload = element.onreadystatechange = function (e) {
                                if (element.readyState && element.readyState !== 'complete' && element.readyState !== 'loaded') {
                                    return;
                                }

                                window.setTimeout(()=> {
                                    resolve(e);
                                });
                            };
                            element.onerror = function (e) {
                                window.setTimeout(()=> {
                                    reject(e);
                                });
                            };
                        });



                        promises[url] = deferred;
                    }

                    return promises[url];
                };
            }

            /**
             * Dynamically loads the given script
             * @param src The url of the script to load dynamically
             * @returns {*} Promise that will be resolved once the script has been loaded.
             */
            export let loadScript = loader(function (src) {
                var script = document.createElement('script');

                script.src = src;

                document.body.appendChild(script);
                return script;
            });

            /**
             * Dynamically loads the given CSS file
             * @param href The url of the CSS to load dynamically
             * @returns {*} Promise that will be resolved once the CSS file has been loaded.
             */
            export let loadCSS = loader(function (href) {
                var style = document.createElement('link');

                style.rel = 'stylesheet';
                style.type = 'text/css';
                style.href = href;

                document.head.appendChild(style);
                return style;
            });




// WEBPACK FOOTER //
// ./src/main/webapp/components/scriptLoader.ts